if (typeof document === "undefined") return;
var createStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject
) {
	var linkTag = document.createElement("link");

linkTag.rel = "stylesheet";

linkTag.type = "text/css";

if (__webpack_require__.nc) {
  linkTag.nonce = __webpack_require__.nc;
}
linkTag.href = fullhref;

	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	if (oldTag) {
            oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
          } else {
            document.head.appendChild(linkTag);
          }
	return linkTag;
}
var findStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var loadStylesheet = function (chunkId) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	"index": 0,

};

__webpack_require__.f.miniCss = function (chunkId, promises) {
	var cssChunks = {
"src_domain_components_advanced-scheduling-section_AdvancedSchedulingSection_ctrl_tsx-src_doma-6fd480": 1,
"src_domain_components_overview-tab_index_ts-node_modules_ingenico_react-ui_src_lib_components-edee5d": 1,
"src_domain_components_version-details-content_VersionDetailsContent_tsx-src_domain_hooks_useD-b9dac4": 1,
"src_domain_domain_models_asset_model_ts-src_domain_hooks_useManagePaginatedDatagridRowSelecti-9c04a3": 1,
"src_domain_pages_app-module-details_AppModuleDetails_ctrl_tsx-src_domain_components_duplicate-ddf99a": 1,
"src_domain_pages_application-details-page_index_ts-src_domain_components_publish-modal_Publis-9b9057": 1,
"src_domain_pages_applications-page_ApplicationsPage_ctrl_tsx-src_domain_components_applicatio-fc9134": 1,
"src_domain_pages_applications-version-details-page_ApplicationsVersionDetails_ctrl_tsx": 1,
"src_domain_pages_configuration-profile-detail-page_ConfigurationProfileDetailPage_ctrl_tsx-sr-23bbf8": 1,
"src_domain_pages_configuration-profile-list-page_ConfigurationProfileListPage_ctrl_tsx-src_do-8cb4c8": 1,
"src_domain_pages_create-application-page_CreateApplicationPage_ctrl_tsx-src_domain_components-8af1b2": 1,
"src_domain_pages_create-deployment-page_CreateDeploymentPageMain_ctrl_tsx-src_domain_componen-96e8bd": 1,
"src_domain_pages_create-os-page_CreateOsPage_ctrl_tsx-src_domain_components_application-form--f5bbeb": 1,
"src_domain_pages_create-os-version-page_CreateOsVersionPage_ctrl_tsx": 1,
"src_domain_pages_create-package-page_CreatePackagePage_ctrl_tsx-src_domain_components_applica-11ff99": 1,
"src_domain_pages_deploy-deletion-request-page_DeployDeletionRequestPage_ctrl_tsx-src_domain_c-f3b7a2": 1,
"src_domain_pages_deployment-details-page_DeploymentDetailsPage_ctrl_tsx-src_domain_components-dd885f": 1,
"src_domain_pages_deployment-target-device-details-page_DeploymentTargetDeviceDetailsPage_ctrl_tsx": 1,
"src_domain_pages_deployments-page_Deployments_ctrl_tsx-src_domain_components_deployment-list_-d9f08b": 1,
"src_domain_pages_logical-devices-input-page_LogicalDevicesInputPage_ctrl_tsx": 1,
"src_domain_pages_modules-page_ModulesPage_ctrl_tsx-src_domain_components_module_module-list_m-64cd2f": 1,
"src_domain_pages_os-application-details-page_OSApplicationDetailsPage_ctrl_tsx-src_domain_com-453096": 1,
"src_domain_pages_os-page_OsPage_ctrl_tsx": 1,
"src_domain_pages_rki-service-details-page_RkiServiceDetailsPage_ctrl_tsx-src_domain_component-3e6a13": 1,
"src_domain_pages_rki-service-organization-details-page_RkiServiceOrganizationDetailsPage_ctrl-da37d1": 1,
"src_domain_pages_system-package-details-page_SystemPackageDetailsPage_ctrl_tsx-src_domain_com-ed00f2": 1,
"src_domain_pages_system-package-module-details_SystemPackageModuleDetails_ctrl_tsx-src_domain-4d35b2": 1,

};
	if (installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if (installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = loadStylesheet(chunkId).then(
				function () {
					installedCssChunks[chunkId] = 0;
				},
				function (e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

var oldTags = [];
var newTags = [];
var applyHandler = function (options) {
	return {
		dispose: function () {
			for (var i = 0; i < oldTags.length; i++) {
				var oldTag = oldTags[i];
				if (oldTag.parentNode) oldTag.parentNode.removeChild(oldTag);
			}
			oldTags.length = 0;
		},
		apply: function () {
			for (var i = 0; i < newTags.length; i++) newTags[i].rel = "stylesheet";
			newTags.length = 0;
		}
	}
}
__webpack_require__.hmrC.miniCss = function (chunkIds, removedChunks, removedModules, promises, applyHandlers, updatedModulesList) {
	applyHandlers.push(applyHandler);
	chunkIds.forEach(function (chunkId) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		var oldTag = findStylesheet(href, fullhref);
		if (!oldTag) return;
		promises.push(new Promise(function (resolve, reject) {
			var tag = createStylesheet(
				chunkId,

				/**
					If dynamically add link tag through dom API and there is already a loaded style link, browsers sometimes treats the new link tag as the same link, and won't fetch the new style.
					Use query to avoid browser cache the link tag, force to re-fetch new style, this is the same strategy as updateCss API, this can happen during lazy compilation
				 */
				`${fullhref}?${Date.now()}`,
				oldTag,
				function () {
					tag.as = "style";
					tag.rel = "preload";
					resolve();
				},
				reject
			);
			oldTags.push(oldTag);
			newTags.push(tag);
		}))
	});
}

// no prefetch
// no preload